var DynamicInput = require('./dynamicInput');


module.exports = DynamicInput.extend({

    idAttribute: 'key',

    defaults: _.extend( {}, DynamicInput.prototype.defaults, {

        isValid: false // N/A

    }),

    setValue: function( value ) {

        this.set({
            value: value,
            isValid: value.length > 0
        });

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/textStamp/variableInputs/variableInputModel.js
 ** module id = 340
 ** module chunks = 0
 **/